import dynamic from 'next/dynamic';

import Container from 'app/components/common/Container';
const FeatureCard = dynamic(() => import('./FeatureCard'));

export default function VlinkApart({
  data = {},
  justify = 'center',
  background = 'bg-vlink-apart',
  backgroundPosition = 'center',
  isPaddRemove,
}) {
  const justification = {
    center: 'justify-center',
    start: 'justify-start',
    end: 'justify-end',
    between: 'justify-between',
    around: 'justify-around',
    evenly: 'justify-evenly',
  };
  return (
    <div
      className={`${background} ${backgroundPosition} ${isPaddRemove ? '' : 'md:py-[55px] py-[30px]'} bg-no-repeat`}
    >
      <Container className="text-center">
        <div className="md:mb-[34px] mb-[30px]">
          <h1 className="font-[800] xl:text-[50px] md:text-[32px] text-[26px] title_hd mb-4 leading-tight">
            {data?.h1_black}
          </h1>
          <div>
            <p className="font-[400] text-[16px] text-[#353535] leading-tight w-full max-w-[800px] mx-auto">
              {data?.p}
            </p>
          </div>
        </div>

        <section className={`flex flex-wrap  ${justification[justify]}`}>
          {data?.VLink_Apart_Content?.length > 0 &&
            data?.VLink_Apart_Content?.map((cardData, index) => (
              <FeatureCard key={index} data={cardData} />
            ))}
        </section>
      </Container>
    </div>
  );
}
